import React, { useState, useRef, useEffect} from 'react';
import FolderIcon from '../components/folderIcon';
import Pill from '../components/pill';
import { getImagePaths, loadImages, loadCodeProjects } from '../utils/imageLoader';
import imageConfig from "../config/json/imageConfig.json";
import CustomModal from '../components/modal';
import ImageGallery from '../components/imageGallery';
import ProjectGallery from '../components/projectGallery';

const MyWorkPage = ({ theme, folders, onFolderClick, onBackClick }) => {
  const [hoveredFolder, setHoveredFolder] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [artImages, setArtImages] = useState({
    pixel: [],
    digital: [],
    traditional: []
  });
  const [codeProjects, setCodeProjects] = useState([]);
  const [isLoading, setIsLoading] = useState({
    pixel: true,
    digital: true,
    traditional: true,
    code: true
  });

  // Load all images
  useEffect(() => {
    const loadAllImages = async () => {
      try {
        const [pixelArt, digitalArt, traditionalArt, projects] = await Promise.all([
          loadImages('pixelart'),
          loadImages('digitalart'),
          loadImages('traditionalart'),
          loadCodeProjects()
        ]);
        
        setArtImages({
          pixel: pixelArt,
          digital: digitalArt,
          traditional: traditionalArt
        });
        setCodeProjects(projects);
        
        setIsLoading({
          pixel: false,
          digital: false,
          traditional: false,
          code: false
        });
      } catch (error) {
        console.error('Error loading images:', error);
      }
    };
    
    loadAllImages();
  }, []);

  return (
    <div className='myWorkPage'>
      {/* Skills Section */}
      <div className="skillsContainer">
        <div className="skillColumn">
          <h3>Development</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {['HTML/CSS', 'Javascript', 'React', 'Python', 'SQL', 'Java', 'Gatsby', 'Next.JS', 'MaterialUI'].map(skill => (
              <Pill 
                key={skill}
                title={skill}
                theme={theme}
              />
            ))}
          </div>
        </div>
        
        <div className="skillColumn">
          <h3>Design</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {['Axure', 'Figma', 'Storyboard Pro', 'Clip Studio Paint', 'Adobe Photoshop', 'Adobe Illustrator'].map(skill => (
              <Pill 
                key={skill}
                title={skill}
                theme={theme}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Portfolio Links */}
      <div className='portfolioContainer'>
        <div className="folderChoices">
          {folders.map((folder) => (
            <div
              key={folder.id}
              onMouseEnter={() => setHoveredFolder(folder.id)}
              onMouseLeave={() => setHoveredFolder(null)}
            >
              <FolderIcon
                theme={theme}
                label={folder.label}
                isHovered={hoveredFolder === folder.id}
                onClick={() => onFolderClick(folder.id)}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Code Projects Section */}
      <div className='codeProjectsContainer'>
        <h3>Web Development Projects</h3>
        {isLoading.code ? (
          <p>Loading projects...</p>
        ) : (
          <ProjectGallery 
            projects={codeProjects} 
            theme={theme}
          />
        )}
      </div>

      {/* Illustration Section */}
      <div className='illuContainer'>
        <h3>Illustration</h3>
        
        <h5>Pixel Art</h5>
        {isLoading.pixel ? (
          <p>Loading pixel art...</p>
        ) : (
          <ImageGallery
            images={artImages.pixel}
            onImageClick={setSelectedImage}
            className="grid-item"
          />
        )}
        
        <h5>Other Digital Art</h5>
        {isLoading.digital ? (
          <p>Loading digital art...</p>
        ) : (
          <ImageGallery
            images={artImages.digital}
            onImageClick={setSelectedImage}
            className="grid-item"
          />
        )}
        
        <h5>Traditional Art</h5>
        {isLoading.traditional ? (
          <p>Loading traditional art...</p>
        ) : (
          <ImageGallery
            images={artImages.traditional}
            onImageClick={setSelectedImage}
            className="grid-item"
          />
        )}

        <CustomModal
          isOpen={!!selectedImage}
          onRequestClose={() => setSelectedImage(null)}
          theme={theme}
        >
          {selectedImage && (
            <img 
              src={selectedImage} 
              style={{ maxWidth: '100%', maxHeight: '80vh' }} 
              alt="Enlarged artwork" 
            />
          )}
        </CustomModal>
      </div>

      {/* Other Projects */}
      <div className='otherDevContainer'>
        <h3>Other Dev Projects</h3>
        <p>This website!</p>
      </div>
    </div>
  );
};

export default MyWorkPage;